import { defineMessages } from "@/i18n";
import en from "./en";

export const agentActivityResourceMessages = defineMessages(
  "agent-activity-resource",
  en,
);
